import { JSX } from "react"
import { Typography } from "@mui/material"

export const SessionModalMessage = {
    'REMOTE_LAUNCH_INITIALIZED': (
        <Typography>
            One minute we are sending the link
        </Typography>
    ),
    'REMOTE_LAUNCH_SUCCESS': (
        <div>
            <Typography>
                SUCCESS!
            </Typography>
            <Typography sx={{ padding: "8px 0px" }}>
                An email with the child's remote launch link was sent to the requested email on file.
            </Typography>
            <Typography sx={{ paddingBottom: "8px" }}>
                The link is good for 2 weeks.
            </Typography>
        </div>
    ),
    'REMOTE_LAUNCH_FAILURE': (
        <div>
            <Typography>Ooops</Typography>
            <Typography>Something went wrong, please try again in a few minutes</Typography>
        </div>
    ),
    'PARENT_SEND_GENERAL_INFORMATION_SUCCESS': (
        <div>
            <Typography>
                SUCCESS!
            </Typography>
            <Typography sx={{ padding: "8px 0px" }}>
                The general information email has been sent
            </Typography>
        </div>
    ),
    "TRIAGE_GENERATION_INITIALIZED": (
        <div>
            <Typography>
                One minute, we are making the report
            </Typography>
        </div>
    ),
    "UNREAD_TRIAGE_GENERATION_INITIALIZED": (
        <div>
            <Typography>
                One minute, we are making the report of the children in Actions Needed
            </Typography>
        </div>
    ),
    "TRIAGE_NO_SESSIONS_FOUND": (
        <div>
            <Typography>
                Error, no completed sessions were found with the given infomration, please select a new search parameter.
            </Typography>
        </div>
    ),
}
